(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muze-collaborators"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-collab-gallery]');
    if (!sections.length) return;

    sections.forEach((gallery) => {
      const track = gallery.querySelector('[data-collab-track]');
      const prev = gallery.querySelector('[data-collab-prev]');
      const next = gallery.querySelector('[data-collab-next]');
      if (!track || !prev || !next) return;

      const getStep = () => {
        const slide = track.querySelector('.collab__slide');
        if (!slide) return track.clientWidth * 0.7;
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return slide.offsetWidth + gap;
      };

      const updateArrows = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        prev.toggleAttribute('disabled', track.scrollLeft <= 0);
        next.toggleAttribute('disabled', track.scrollLeft >= max);
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
